import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e39ee4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-text-[#211F58] tw-text-[13px] tw-font-medium tw-font-[Poppins]" }
const _hoisted_2 = { class: "tw-text-[#231F20] tw-text-[12px] tw-font-[Poppins]" }
const _hoisted_3 = { class: "tw-text-[#387DFF] tw-text-[12px] tw-font-[Poppins]" }

import { computed, Ref, ref, watch } from "vue";
import CustomTable from "@/components/common/customTable.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { getComponentUiText } from "@/utils/utilities";
import CustomDropDownItem from "../common/customDropDownItem.vue";
import ButtonShowMore from "../common/setting/buttonShowMore.vue";
import { IVendorProvider } from "@/interfaces/vendor";


export default /*#__PURE__*/_defineComponent({
  __name: 'currentVendorsTable',
  props: {
  tableData: {
    type: Array as () => IVendorProvider[],
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["select:row", "delete:vendor", "edit:vendor"],
  setup(__props, { emit }) {

const props = __props;



const tableFields = [
  {
    text: getComponentUiText(
      "app-modal-manage-vendor-current-vendor-table-name-title-1",
    ),
    value: "name",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase !tw-pr-0",
    valueClass: "xl:tw-w-[240px] tw-w-[180px]",
  },
  {
    text: getComponentUiText(
      "app-modal-manage-vendor-current-vendor-table-description-title-1",
    ),
    value: "description",
    headerClass:
      "tw-text-[#211F58] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    valueClass: "!tw-py-[20px] tw-w-fit md:tw-w-[400px] tw-w-[300px]",
  },
  {
    text: getComponentUiText(
      "app-modal-manage-vendor-current-vendor-table-url-title-1",
    ),
    value: "url",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    valueClass: "!tw-pr-[12px] !tw-py-[20px]",
  },
  {
    text: "",
    value: "action",
    headerClass: "",
    valueClass: "tw-w-[45px] !tw-px-[5px] !tw-py-[14.25px]",
  },
];

const handleSelectData = (selectedIds: number[]) => {
  const data = selectedIds.map((id) =>
    props.tableData.find((item) => item.id === id),
  );
  emit("select:row", data);
};

const getDescription = (description: string) => {
  const div = document.createElement("div");
  div.innerHTML = description;
  return div.textContent || div.innerText || "";
};

const handleDeleteVendor = (item: IVendorProvider) => {
  emit("delete:vendor", item);
};

const handleEditVendor = (item: IVendorProvider) => {
  emit("edit:vendor", item);
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomTable, {
    columns: tableFields,
    data: __props.tableData,
    "height-tb": true,
    "is-loading": __props.isLoading,
    "custom-class": `recipents-table `,
    "empty-text": 
      _unref(getComponentUiText)('app-modal-manage-vendor-empty-vendor-title-1')
    ,
    onUpdateSelectedRows: _cache[0] || (_cache[0] = ($event: any) => (handleSelectData($event)))
  }, {
    "cell(name)": _withCtx((data) => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(data.item.name), 1)
    ]),
    "cell(description)": _withCtx((data) => [
      _createElementVNode("span", _hoisted_2, _toDisplayString(getDescription(data.item.description)), 1)
    ]),
    "cell(url)": _withCtx((data) => [
      _createElementVNode("span", _hoisted_3, _toDisplayString(data.item.url), 1)
    ]),
    "cell(action)": _withCtx((data) => [
      _createVNode(ButtonShowMore, {
        "id-popover": 'popover-btn-action-manage-vendor-table-' + data.item.id,
        "is-from-notification": true
      }, {
        default: _withCtx(() => [
          _createVNode(CustomDropDownItem, {
            style: 'normal',
            "id-text": 'app-modal-manage-vendor-edit-vendor-title-1',
            "style-text": 'tw-w-[129px] !tw-leading-[100%]',
            onClick: () => handleEditVendor(data.item)
          }, null, 8, ["onClick"]),
          _createVNode(CustomDropDownItem, {
            "id-text": 'app-modal-manage-vendor-delete-vendor-title-1',
            style: 'danger',
            "style-text": 'tw-w-[129px] !tw-leading-[100%]',
            onClick: () => handleDeleteVendor(data.item)
          }, null, 8, ["onClick"])
        ]),
        _: 2
      }, 1032, ["id-popover"])
    ]),
    _: 1
  }, 8, ["data", "is-loading", "empty-text"]))
}
}

})